/* eslint-disable @typescript-eslint/no-explicit-any */
import CarCarousel from '@apps/components/CarCarousel';
import { TitleDivider } from '@stack/ui/components';
import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';

import { DesktopWrapper, MobileWrapper } from './styles';

const AdsContainer = dynamic<any>(() => import('../AdsContainer'), {
  ssr: false,
});

export type RelatedCarSectionProps = {
  cars: any;
  webView?: boolean;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const RelatedCarSection: React.FC<RelatedCarSectionProps> = (props) => {
  const { cars, webView = false } = props;
  // ======================= HOOKS

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS

  // ======================= VARIABLES

  // ======================= RENDER FUNCTIONS

  // ======================= VIEWS
  if (isEmpty(cars)) return null;
  return (
    <TitleDivider title="Same Brand">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CarCarousel cars={cars ?? []} webView={webView} />
        {/* Ads Section */}
        {!webView && (
          <MobileWrapper
            className="adsbygoogle"
            style={{
              backgroundColor: '#F7F7F7',
            }}
          >
            {/* <AdSense
              adSlot={'5942712071'}
              style={{
                display: 'block',
              }}
            /> */}
            <AdsContainer
              adSlot={'5942712071'}
              style={{
                display: 'block',
              }}
              localPlacement={'sm_listing'}
            />
          </MobileWrapper>
        )}
        {!webView && (
          <DesktopWrapper
            className="adsbygoogle"
            style={{
              backgroundColor: '#F7F7F7',
              justifyContent: 'center',
            }}
          >
            {/* <AdSense
              adSlot={'1910211105'}
              style={{
                display: 'block',
              }}
            /> */}
            <AdsContainer
              adSlot={'1910211105'}
              style={{
                display: 'block',
              }}
              localPlacement={'xl_listing'}
            />
          </DesktopWrapper>
        )}
      </div>
    </TitleDivider>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default RelatedCarSection;
